import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Store
import { RootState } from '../store';

// Configs
import { INDICATORS, IndicatorType } from '../../configs/indicators.config';
import { SurveySelectedType } from '../../configs/types';

export type LevelSelectedType = {
  level: string;
  admin1RegionID?: string;
};

interface modelSurfaceState {
  allSurveys: any;
  surveyList: any;
  surveySelected: SurveySelectedType | null;
  levelList: any;
  levelSelected: LevelSelectedType;
  indicatorsObject: any;
  indicatorSelected: IndicatorType;
  admin2FeaturesData: any;
  admin2FeaturesIndicatorSelectedData: any;
}

export const LEVEL_ALL: LevelSelectedType = { level: 'ALL' };

const initialState: modelSurfaceState = {
  allSurveys: null,
  surveyList: null,
  surveySelected: null,
  levelList: null,
  levelSelected: LEVEL_ALL,
  indicatorsObject: {},
  indicatorSelected: INDICATORS[0],
  admin2FeaturesData: {},
  admin2FeaturesIndicatorSelectedData: [],
};

export const admin2EstimatesSlice = createSlice({
  name: 'admin2EstimatesSlice',
  initialState,
  reducers: {
    setAllSurveys: (state, action: PayloadAction<object>) => {
      state.allSurveys = action.payload;
    },
    setSurveyList: (state, action: PayloadAction<object>) => {
      state.surveyList = action.payload;
    },
    setSurveySelected: (state, action: PayloadAction<SurveySelectedType>) => {
      state.surveySelected = action.payload;
    },
    setLevelList: (state, action: PayloadAction<any>) => {
      state.levelList = [LEVEL_ALL, ...action.payload];
    },
    setLevelSelected: (state, action: PayloadAction<LevelSelectedType>) => {
      state.levelSelected = action.payload;
    },
    setIndicatorsObject: (state, action: PayloadAction<object>) => {
      state.indicatorsObject = action.payload;
    },
    setIndicatorSelected: (state, action: PayloadAction<IndicatorType>) => {
      state.indicatorSelected = action.payload;
    },
    setAdmin2FeaturesData: (state, action: PayloadAction<object>) => {
      state.admin2FeaturesData = {
        ...state.admin2FeaturesData,
        ...action.payload,
      };
    },
    setAdmin2FeaturesIndicatorSelectedData: (state, action: PayloadAction<[]>) => {
      state.admin2FeaturesIndicatorSelectedData = action.payload;
    },
  },
});

export const {
  setAllSurveys,
  setSurveyList,
  setSurveySelected,
  setLevelList,
  setLevelSelected,
  setIndicatorsObject,
  setIndicatorSelected,
  setAdmin2FeaturesData,
  setAdmin2FeaturesIndicatorSelectedData,
} = admin2EstimatesSlice.actions;

export const $allSurveys = (state: RootState) => state.admin2EstimatesSlice.allSurveys;
export const $surveyList = (state: RootState) => state.admin2EstimatesSlice.surveyList;
export const $surveySelected = (state: RootState) => state.admin2EstimatesSlice.surveySelected;
export const $levelList = (state: RootState) => state.admin2EstimatesSlice.levelList;
export const $levelSelected = (state: RootState) => state.admin2EstimatesSlice.levelSelected;
export const $indicatorsObject = (state: RootState) => state.admin2EstimatesSlice.indicatorsObject;
export const $indicatorSelected = (state: RootState) => state.admin2EstimatesSlice.indicatorSelected;
export const $admin2FeaturesData = (state: RootState) => state.admin2EstimatesSlice.admin2FeaturesData;
export const $admin2FeaturesIndicatorSelectedData = (state: RootState) =>
  state.admin2EstimatesSlice.admin2FeaturesIndicatorSelectedData;

export default admin2EstimatesSlice.reducer;
